import {
  CardPaymentDto,
  ClientInfo,
  ICart,
  IPaymentConfiguration,
  MobilePaymentDto,
  MobilePaymentType,
} from "@dining/api-client";
import { AppContextType, AppType } from "@microsoft/metaos-appcontextutils";
import { CardFormValues } from "./sharedTypes";

/**
 * Returns whether Apple Pay JS is supported on the current device.
 * @returns Whether Apple Pay JS is supported.
 */
export const supportsApplePay = () => {
  return "ApplePaySession" in window && ApplePaySession !== undefined;
};

export function createMobilePayment(
  event: ApplePayJS.ApplePayPaymentAuthorizedEvent,
  context: AppContextType,
): MobilePaymentDto {
  return new MobilePaymentDto({
    mobilePaymentType: MobilePaymentType.ApplePay,
    token:
      process.env.APP_ENV === "dev" || process.env.APP_ENV === "local"
        ? "null"
        : JSON.stringify(event.payment.token.paymentData),
    paymentSource: new ClientInfo(paymentSourceFromContext(context)),
  });
}

export function createCardPayment(data: CardFormValues, context: AppContextType) {
  return new CardPaymentDto({
    accountNumber: data.cardNumber.replace(/\s/g, ""),
    cvv: data.cvc,
    expirationMonth: data.expiryDate.split("/")[0].replace(/\s/g, ""),
    expirationYear: data.expiryDate.split("/")[1].replace(/\s/g, "").padStart(4, "20"),
    paymentSource: new ClientInfo(paymentSourceFromContext(context)),
  });
}

export function createPaymentRequest(cart: ICart, config: IPaymentConfiguration) {
  const request: ApplePayJS.ApplePayPaymentRequest = {
    countryCode: config.countryCode || "US",
    currencyCode: config.currencyCode || "USD",
    merchantCapabilities: ["supports3DS"],
    supportedNetworks:
      config.supportedNetworks?.reduce((acc, network) => {
        if (network.active && network.network) {
          acc.push(network.network.toLowerCase());
        }
        return acc;
      }, [] as string[]) || [],
    total: {
      label: cart.cafeName || "Unknown Cafe",
      type: "final",
      amount: cart.totalAmount.amount?.toString() || "0",
    },
  };
  return request;
}

const paymentSourceFromContext = (context: AppContextType) => {
  return {
    source: context.appType === AppType.standAlone ? "WebApp" : "Places",
  };
};
